<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useStore } from '../../../../store/index'
import { addRetargetingScripts } from '../../../../utils/retargeting'
import { ref } from 'vue'

const emit = defineEmits(['nextStep'])
const { t } = useI18n()
const store = useStore()

const state = ref(store.state).value
const istate = ref(store.urlParameters?.flow).value === 'agewithnoemailstate' && state ? true : false
const isLoading = ref(false)
const trackingDomain = store.trackingDomain

function openUrl(actionId: number) {
    isLoading.value = true

    let campaignUrl = `https://${trackingDomain}/click`
    if (actionId > 0) {
        campaignUrl = campaignUrl + `/${actionId}`
    }
        addRetargetingScripts()
        setTimeout(() => {
            window.location.href = campaignUrl
        }, 1500)
}
</script>

<template>
    <div class="flex flex-col items-center w-full max-w-xl mx-auto space-y-5 text-center mt-7">
        <!-- <h1 class="text-[#626c72] text-2xl font-normal tracking-[0.2rem] md:font-semibold uppercase">
            {{ t('age.step1.text1') }}
        </h1> -->
        <h1
            class="text-[#626c72] text-2xl font-normal tracking-[0.2rem] md:font-semibold uppercase"
            v-html="istate ? t(`age.step1.text1state`, { state: state }) : t(`age.step1.text1`)"
        ></h1>
        <h2 class="text-[#677277] tracking-[0.2rem] uppercase"
            v-html="istate ? t(`age.step1.text2state`, { state: state }) : t(`age.step1.text2`)">
        </h2>
        <h2 class="text-[#677277] tracking-[0.2rem] uppercase font-semibold">
            {{ t('age.step1.question') }}
        </h2>

        <div class="flex flex-row items-center justify-center w-full max-w-sm space-x-4 sm:flex-row">
            <button
                :disabled="isLoading"
                class="border border-[#cbcfd2] py-2 px-6 rounded-md text-sm hover:border-red-400 hover:text-red-400 duration-200 uppercase font-bold w-1/2"
                @click="openUrl(1)"
            >
                {{ t('age.step1.answer1') }}
            </button>
            <button
                :disabled="isLoading"
                class="border border-[#cbcfd2] py-2 px-6 rounded-md text-sm hover:border-red-400 hover:text-red-400 duration-200 uppercase font-bold w-1/2"
                @click="openUrl(2)"
            >
                {{ t('age.step1.answer2') }}
            </button>
        </div>
    </div>
</template>
1
<style>
.fadeInUp {
    -webkit-animation: b 0.6s forwards;
    animation: b 0.6s forwards;
}

@-webkit-keyframes b {
    0% {
        opacity: 0;
        transform: translate3d(0, 10rem, 0);
    }

    to {
        opacity: 1;
        transform: translateZ(0);
    }
}

@keyframes b {
    0% {
        opacity: 0;
        transform: translate3d(0, 10rem, 0);
    }

    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>
